import { LinkResourcesResultExtra } from '../link-resources';

export interface MailResultExtra extends LinkResourcesResultExtra {
  inboxFilterOnly?: boolean;
  insertedHeadersAmount?: number;
  prevDateFormat?: string;
  prevDate?: Date;
  useSourceFilters?: boolean;
}
